import { keyframes } from '@emotion/react';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
import { Colors } from '../../../theme';
import { VisuallyHidden } from '../VisuallyHidden';
const spin = keyframes `
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
const sizes = {
    small: {
        diameter: 20,
        thickness: 4,
    },
    medium: {
        diameter: 30,
        thickness: 6,
    },
    large: {
        diameter: 60,
        thickness: 10,
    },
};
const mapPropToColorValue = (color) => {
    let returnedColor;
    switch (color) {
        case 'black':
            returnedColor = Colors.neutral800;
            break;
        case 'white':
            returnedColor = Colors.neutral100;
            break;
        case 'light':
            returnedColor = Colors.neutral100;
            break;
        case 'dark':
            returnedColor = Colors.neutral800;
    }
    return returnedColor;
};
const Styles = labelStyles('Spinner', {
    root: (props) => [
        {
            animation: `${spin} 0.75s linear infinite`,
            borderStyle: 'solid',
            borderRightColor: 'transparent',
            borderRadius: '50%',
            opacity: 0.7,
        },
        withModifier(props.size, {
            height: sizes[props.size].diameter,
            width: sizes[props.size].diameter,
            borderWidth: `${sizes[props.size].thickness}px`,
        }),
        withModifier(props.color, {
            borderColor: mapPropToColorValue(props.color),
            borderRightColor: 'transparent',
        }),
    ],
});
export const Spinner = ({ ariaLabel = 'Loading', color = 'black', size = 'small', }) => {
    const props = { ariaLabel, color, size };
    return (isolateComponent("div", { css: Styles.root(props), "data-testid": "spinner", role: "status" },
        isolateComponent(VisuallyHidden, null, ariaLabel)));
};
//# sourceMappingURL=Spinner.js.map
// @zapier/design-system@6.14.1 (10126c41d)
